import { useState, useCallback, useRef, useContext } from 'react';
import { ToastContext, resolveToastArgs } from '../contexts/ToastContext';

const useLocalToast = (duration = 3200) => {
  const [toast, setToast] = useState(null);
  const timerRef = useRef(null);

  const showToast = useCallback((arg1, arg2, arg3) => {
    if (timerRef.current) clearTimeout(timerRef.current);
    const { message, type, options } = resolveToastArgs(arg1, arg2, arg3);
    if (!message) return;

    const toastDuration = Number(options?.duration);
    const effectiveDuration = Number.isFinite(toastDuration) && toastDuration > 0
      ? toastDuration
      : (type === 'error' ? Math.max(duration, 4000) : duration);

    setToast({
      message,
      type,
      id: `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
      ...options
    });

    if (!options?.persistent) {
      timerRef.current = setTimeout(
        () => setToast(null),
        effectiveDuration
      );
    } else {
      timerRef.current = null;
    }
  }, [duration]);

  const hideToast = useCallback(() => {
    if (timerRef.current) clearTimeout(timerRef.current);
    setToast(null);
  }, []);

  return { toast, showToast, hideToast };
};

const useToast = (duration = 3200) => {
  const context = useContext(ToastContext);
  const fallback = useLocalToast(duration);
  return context || fallback;
};

export default useToast;
